export const requiredFormItem = (message?: string) => {
  return {
    required: true,
    message: message ?? '',
  }
}
